<section class="unsubscribed-sec">
    <div class="unsubscribed-head">Verify Your Email!</div>
    <div class="unsubscribed-text">We have sent a verification email to <a href="mailto:good@yopmail.com">good@yopmail.com</a></div>
    <div class="unsubscribed-btn"><button (click)="resendMail()" class="btn btn-primary-btn">Resend Verification Email</button></div>
</section>
